/**************************************************
 * Nombre:       Formulario_Pedido_Envio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {
    FlagOutlined,
    LocalShippingOutlined,
    LocationCityOutlined,
    MapsHomeWorkOutlined,
    SignpostOutlined,
    TimelapseOutlined
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";


const Formulario_Pedido_Envio = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de entrega</Typography>
                </Grid>


                <Grid container size={6}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Departamento'} dato={'departamento'} {...props}
                                  editable={false}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LocationCityOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}
                                  editable={false}
                    />
                </Grid>
                <Grid container size={12}>
                    <IngresoTexto Icono={MapsHomeWorkOutlined} nombre={'Barrio o Localidad'}
                                  dato={'barrio'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SignpostOutlined} nombre={'Direccion'} dato={'direccion'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={SignpostOutlined} nombre={'Valor'} dato={'valorEnvio'} {...props}
                                   editable={false}/>

                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={LocalShippingOutlined} nombre={'Empresa Envio'}
                                  dato={'empresaEnvio'} {...props} editable={false}/>
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={TimelapseOutlined} nombre={'Tiempo Llegada (Dias)'}
                                  dato={'tiempoEnvio'} {...props} editable={false}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Indicaciones adicionales'} dato={'indicaciones'} {...props} />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Pedido_Envio